<template>
  <div class="container">
    <i
      v-show="fetching"
      class="fa fa-spinner fa-spin"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { mainStore } from 'operass-spa/src/store/index';

export default {
  name: 'CcSpinner',
  computed: {
    ...mapState(mainStore, ['fetching']),
  },
};
</script>

<style scoped>
  .container {
    color: #fff;
    position: absolute;
    float: right;
    left: 0px;
    right: 2px;
    z-index: 1;
    margin-top: 15px;
  }
</style>
